
    <div *ngIf="model && (model.files || model.invoiceFile)">
      <div *ngFor="let file of files">
        <a href="{{ file.url }}" target="_blank">{{ file.name }}</a><br>
      </div>
    </div>
    <div *ngIf="model && model.attachments">
      <div *ngFor="let attachment of attachments">
        <a href="{{ attachment.url }}" target="_blank">{{ attachment.name }}</a><br>
      </div>
    </div>
  